import classNames from 'classnames';

export const GetNodeClassNames = (node, classes) => classNames([
  classes.baseMenuItem,
  node.isSelected ? [classes.selectedMenuItem, 'selected'] : classes.normalMenuItem,
  `menu-item-${node.id}`,
]);
